import { FetchUpcomingCatalogsResponse } from '@/redux/modules/catalog/catalogs/catalog.api';
import { TypedActionWithPayloadMetaActionTime } from '@/types/redux';

export const LOAD_UPCOMING_CATALOGS_FAIL = 'la/domain/upcomingCatalogs/LOAD_FAIL';
export const LOAD_UPCOMING_CATALOGS_REQUEST = 'la/domain/upcomingCatalogs/LOAD_REQUEST';
export const LOAD_UPCOMING_CATALOGS_SUCCESS = 'la/domain/upcomingCatalogs/LOAD_SUCCESS';
export type LoadUpcomingCatalogsSuccessAction = TypedActionWithPayloadMetaActionTime<
    typeof LOAD_UPCOMING_CATALOGS_SUCCESS,
    FetchUpcomingCatalogsResponse['data']
>;
